import React from 'react';

import NotFoundInfo from 'apps/promo/components/info/NotFoundInfo';
import ReqAndMoneyInfo from 'apps/promo/components/info/ReqAndMoneyInfo';
import { useExtra } from 'apps/promo/hooks/selectors';

const RouterForInfoPage = () => {
    const extra = useExtra();

    return extra.strapiApi?.status === 'success' ? <ReqAndMoneyInfo extra={extra.strapiApi} /> : <NotFoundInfo />;
};

export default RouterForInfoPage;
